<div class="header-padding" style="height: 46px;">
  @if (isWelcome) {
    <div class="header-container">
      <app-customer-branding-logo></app-customer-branding-logo>
      <app-language-selection></app-language-selection>
    </div>
  }
  @if (!isWelcome) {
    <div>
      <div class="header-container progress-header-container" [class.white-font]="useWhiteFontColor">
        <div style="cursor: pointer;" (click)="back()" [class.white-font]="useWhiteFontColor">
          @if (!useWhiteFontColor) {
            <img ngSrc="../../../../assets/img/back-carret.svg" height="24" width="24">
          }
          @if (useWhiteFontColor) {
            <img ngSrc="../../../../assets/img/back-carret-white.svg" height="24" width="24">
          }
        </div>
        <div class="label1" [class.white-font]="useWhiteFontColor">
          {{ title }}
        </div>
        <div style="min-height: 34px; display: flex; flex-direction: column; justify-content: center">
          @if (showClose && !useWhiteFontColor) {
            <img style="cursor: pointer;" (click)="cancel()" ngSrc="../../../../assets/img/x-icon.svg" height="24" width="24">
          }
          @if (showClose && useWhiteFontColor) {
            <img style="cursor: pointer;" (click)="cancel()" ngSrc="../../../../assets/img/x-icon-white.svg" height="24" width="24">
          }
        </div>
      </div>
      @if (showProgressIndicator) {
        <app-progress-indicator [currentStep]="progress"></app-progress-indicator>
      }
    </div>
  }
</div>
